import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { OfferTypeContainer } from '../../containers/filters/OfferTypeContainer';

export const offerType: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: OfferTypeContainer,
};
